import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationTopicsApi } from '@/Domain/api/Conversation/ConversationTopics.api';
import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';

export const useConversationTopicUpdate = () => {
  const { t } = useTranslation('insights_page');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [`${Endpoint.conversationTopics.delete}-update`],
    mutationFn: (topic: TopicDto) => ConversationTopicsApi.update(topic),
    onSuccess: (data) => {
      queryClient.setQueryData(
        [`${Endpoint.conversationTopics.list}-list`],
        (prevData: TopicDto[]) =>
          prevData.map((item) => (item.id === data.id ? { ...item, ...data } : item)),
      );

      toast.success(t('toast.update_topic.success'));
    },
  });

  const handleUpdateTopic = (topic: TopicDto) => mutation.mutateAsync(topic);

  return { handleUpdateTopic, isPending: mutation.isPending };
};
